
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { REQUEST_API_KEY, RESET_API_KEY } from 'modules/Api/constants';
import styled from 'styled-components';
import {BrowserRouter as Router, Route, Switch, withRouter, Link } from 'react-router-dom';
import { selectApiKey } from 'modules/Api/selectors';
import {Card} from '../../../components/Card';
import {Loader} from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { BaseComponent } from '../../../components/BaseComponent';
import { selectWork } from '../../../modules/Api/selectors';
import { REQUEST_PASSWORD_RESET, REQUEST_PASSWORD_SET } from '../../../modules/Api/constants';
import { FormField } from '../../../components/FormFields';

const baseState = {
  email:'',
  password:'',
  password2: '',
  reset_email : "",
  error : null,
  loading: false
}

/* eslint-disable react/prefer-stateless-function */
class PasswordResetComp extends BaseComponent {

  constructor(props) {
    super(props, {...baseState});
  }

  resetSelf(){
    this.setState( { ...baseState});
    this.props.history.push("/login");
  }

  submit(){
    this.props.passwordReset(this.state.email, (result) =>{

      if(result && result.result){
        this.setState({ resetComplete: true, ...baseState});
      } else {
        this.updateState({error : true});
      }
    });
  }

  onInputChange(e){
    this.updateState(e.target.name, e.target.value);
  }

  render(){

    if(this.props.loading) return <Loader onCard/>
    if(this.state.resetComplete) return this.renderResetComplete();

    let footer = <Button isPrimary onClick={ this.submit.bind(this)}>{this.lbl('reset')}</Button>;
    let {email, error} = this.state;

    return  <Card hasHeader={true} headerTitle={this.lbl('login.reset.request')} footer={footer}>
    { error ? <div className='well error'> {this.lbl('error')}  </div> : '' }
      <FormField label={this.lbl('email')}>
      <input
        className="input-element"
        autoComplete="email"
        id="email"
        type="email"
        name="email"
        placeholder="e-mail@address.com"
        value={email}
        onChange={this.onInputChange.bind(this)}
      />
      </FormField>
    </Card>

  }

  renderResetComplete(){
    return <Card isPrimary headerTitle={this.lbl('login.reset.complete.title')} footer={<Button onClick={this.resetSelf.bind(this)}>OK</Button>}>
      {this.lbl('login.reset.complete.body')}
    </Card>
  }
}

PasswordResetComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({
  apiKey : selectApiKey(),
  loading : selectWork(REQUEST_PASSWORD_RESET)
});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    passwordReset(email, callback){
      dispatch({
        type : REQUEST_PASSWORD_RESET,
        email ,callback
      })
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const PasswordReset = compose(
  withRouter,
  withConnect
)(PasswordResetComp);
